import LegalShell from "./LegalShell";
import {
  LEGAL_LAST_UPDATED,
  PRIVACY_CONTACT_EMAIL,
  SUPPORT_CONTACT_EMAIL,
} from "./legalMeta";

export default function PrivacyPage() {
  return (
    <LegalShell title="Privacy Policy" date={LEGAL_LAST_UPDATED}>
      <div className="legal-callout">
        <p>
          <strong>Summary:</strong> We collect and process information needed
          to run the Service, protect users, prevent abuse, and comply with law.
          We do not sell personal information.
        </p>
      </div>

      <h2>1. Scope</h2>
      <p>
        This Privacy Policy explains how Ateno Inc. (&quot;Ateno,&quot;
        &quot;we,&quot; &quot;us&quot;) collects, uses, stores, and discloses
        information when you use our applications, websites, and related
        services (the &quot;Service&quot;).
      </p>

      <h2>2. Information We Collect</h2>
      <h3>Information you provide</h3>
      <ul>
        <li>account and profile data (such as name, email, and login identifiers)</li>
        <li>content you upload or create (including images and generated outputs)</li>
        <li>support messages, feedback, and communications with us</li>
      </ul>
      <h3>Information collected automatically</h3>
      <ul>
        <li>device, app, and log information (including technical diagnostics)</li>
        <li>usage and performance data (features used, errors, timing)</li>
        <li>security and fraud-prevention signals</li>
      </ul>

      <h2>3. Moderation and Safety Data</h2>
      <p>
        To protect users and the platform, we maintain moderation-related
        records that may include account status (for example active, warned,
        suspended, or banned), moderation reasons/categories, timestamps, action
        source, and internal moderator or system identifiers.
      </p>
      <p>
        We also maintain immutable moderation event logs to support abuse
        prevention, fraud and security response, operational integrity, and
        legal compliance.
      </p>

      <h2>4. How We Use Information</h2>
      <ul>
        <li>provide, maintain, and improve the Service</li>
        <li>authenticate users and secure accounts</li>
        <li>detect, investigate, and prevent abuse, fraud, and policy violations</li>
        <li>enforce platform rules and moderation decisions</li>
        <li>respond to support requests and operational incidents</li>
        <li>comply with legal obligations and protect rights/safety</li>
      </ul>

      <h2>5. Sharing and Disclosure</h2>
      <p>We may disclose information in the following circumstances:</p>
      <ul>
        <li>to service providers operating under contractual confidentiality obligations</li>
        <li>to law enforcement, regulators, courts, or authorities where required by law</li>
        <li>to protect the rights, safety, security, and integrity of users, Ateno, and the public</li>
        <li>as part of a merger, acquisition, financing, or asset transfer</li>
      </ul>

      <h2>6. Retention</h2>
      <p>
        We retain data for as long as reasonably necessary for the purposes in
        this Policy, including service delivery, fraud/safety prevention,
        moderation enforcement, dispute handling, and legal compliance.
      </p>
      <p>
        Moderation and safety records may be retained beyond account closure
        where needed to investigate abuse patterns, defend legal claims, enforce
        terms, or meet regulatory obligations.
      </p>

      <h2>7. Security</h2>
      <p>
        We use administrative, technical, and organizational safeguards designed
        to protect personal information. No system is completely secure, but we
        continuously improve controls and monitoring.
      </p>

      <h2>8. Your Rights and Choices</h2>
      <p>
        Depending on your jurisdiction, you may have rights to access, correct,
        delete, or restrict certain data processing. Some requests may be
        limited where retention is required for legal, security, anti-fraud, or
        moderation-integrity purposes.
      </p>

      <h2>9. Children</h2>
      <p>
        The Service is not directed to children under the minimum age required
        by applicable law. If you believe a child has provided personal data,
        contact us so we can take appropriate action.
      </p>

      <h2>10. Changes to This Policy</h2>
      <p>
        We may update this Policy from time to time. Material changes are
        reflected by updating the &quot;Last updated&quot; date and may also be
        communicated through the Service.
      </p>

      <h2>11. Contact</h2>
      <div className="legal-callout">
        <p>
          Ateno Inc. · Privacy Team ·{" "}
          <a href={`mailto:${PRIVACY_CONTACT_EMAIL}`}>
            {PRIVACY_CONTACT_EMAIL}
          </a>{" "}
          · Support:{" "}
          <a href={`mailto:${SUPPORT_CONTACT_EMAIL}`}>
            {SUPPORT_CONTACT_EMAIL}
          </a>
        </p>
      </div>
    </LegalShell>
  );
}
